import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-124">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-126">
          <h2 className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center mb-1" data-id="element-127">
            El problema que ningún padre quiere admitir...
          </h2>
          <p className="font-nunito text-lg sm:text-xl text-gray-500 italic text-center mb-8" data-id="element-128">
            The problem no parent wants to admit...
          </p>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 sm:p-8 rounded-2xl mb-8" data-id="element-129">
            <p className="text-lg sm:text-xl text-gray-800 leading-relaxed mb-3" data-id="element-130">
              Tu hijo lleva 2 horas frente a la pantalla. Lo llamas a cenar y no
              responde. Le propones jugar y prefiere el celular.
            </p>
            <p className="font-nunito text-base sm:text-lg text-gray-500 italic leading-relaxed" data-id="element-131">
              Your child has been on the screen for 2 hours. You call them for
              dinner and they don't respond.
            </p>
          </div>

          <div className="text-center space-y-8" data-id="element-132">
            <div data-id="element-133">
              <p className="text-xl sm:text-2xl font-nunito font-semibold text-gray-700" data-id="element-134">
                No es tu culpa. Las pantallas están diseñadas para ser
                adictivas.
              </p>
              <p className="font-nunito text-base sm:text-lg text-gray-500 italic mt-1" data-id="element-135">
                It's not your fault. Screens are designed to be addictive.
              </p>
            </div>

            <div data-id="element-136">
              <p className="text-xl sm:text-2xl font-nunito font-bold text-orange-600" data-id="element-137">
                Pero SÍ está en tus manos cambiarlo.
              </p>
              <p className="font-nunito text-base sm:text-lg text-orange-400 italic mt-1" data-id="element-138">
                But YOU can change it.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}